import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import FormPage from './handleProduct/PurchaseFormPage';
import PaymentPage from './handleProduct/PaymentPage';
import ConfirmationPage from './handleProduct/ConfirmationPage';
import ProductDetail from './components/products/productDeatils';
import ProductList from './components/products/ProductList';
import ProductDisplay from './homepage/producthome';
import Home from './home';
import ClassPage2 from './HandleClass/classPage2';
import TermsAndConditions from './PolicyTC/termNcondition';
import PrivacyPolicy from './PolicyTC/policy';
import Contact from './contact/contact';
import AboutFull from './about/aboutFull'
import FemaleWellnessForm from './HandleClass/FemaleWellnessForm';
import YogaRegistrationForm from './HandleClass/YogaForm';
import { useEffect } from "react";
import ScrollToTop from './scrolltop';
import ClassFull from './HandleClass/classfull';
import BlogList from './blogs/bloglist';
import BlogPost from './blogs/BlogPost';

const App = () => {
    window.scrollTo(0, 0);
    if ("scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

  return (
    <Router>
       <ScrollToTop/>
      <Routes>
       
        <Route path="/" element={<Home />} />
        
        <Route path="/form" element={<FormPage />} />
        <Route path="/payment" element={<PaymentPage />} />

        <Route path="/confirmation" element={<ConfirmationPage />} />
        {/* <Route path="/Blog" element={<BlogList />} /> */}
        <Route path='/product' element={<ProductList></ProductList>}></Route>
        {/* <Route path='/product' element={<ProductDetail></ProductDetail>}></Route> */}
        <Route path='/Classes' element={<ClassFull/>}></Route>
       
        <Route path="/product/:id" element={<ProductDetail />} />
        <Route path="/producthome" element={<ProductDisplay />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/t&c" element={<TermsAndConditions/>} />
        <Route path="/contact" element={<Contact/>} />
        <Route path="/FemaleWellnessForm" element={<FemaleWellnessForm/>} />
        <Route path="/About" element={<AboutFull/>} />
        <Route path="/blogs" element={<BlogList />} />
<Route path="/yoga-registration" element={<YogaRegistrationForm />} />
        <Route path="/post/:slug" element={<BlogPost />} />
      </Routes>
    </Router>
  );
};

export default App;
